import { CalculatedPriceRangeFragment } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { ZERO_STATE_PRICE_RANGES } from '../../constants';
import { useRegistryGiftCounts } from '../../RegistryGiftCounts.controller';
import { Page } from '../../telemetry';
import { PriceRange } from '../PriceRange';

interface CountsByPriceProps extends Pick<ReturnType<typeof useRegistryGiftCounts>, 'getPriceRangeTitleAndLink' | 'priceRanges'> {
  page: Page;
  wrapItems: boolean;
  isOpen: boolean;
}

export const CountsByPrice = ({ isOpen, priceRanges, getPriceRangeTitleAndLink, page, wrapItems }: CountsByPriceProps) => {
  const { t } = useTranslation('sharedComponents');
  const { countsByPrice } = t('registryGiftCounts');
  return (
    <>
      <TextV2 typographyVariant="hed2" marginBottom={wrapItems ? 6 : 5} textAlign={wrapItems ? 'center' : 'left'}>
        {countsByPrice()}
      </TextV2>
      <Flex justifyContent="space-evenly" flexWrap={wrapItems ? 'wrap' : 'nowrap'}>
        {(priceRanges || ZERO_STATE_PRICE_RANGES).map((priceRange: CalculatedPriceRangeFragment) => {
          const { title, priceRangeQuery } = getPriceRangeTitleAndLink(priceRange);
          return (
            <PriceRange
              page={page}
              priceRangeQuery={priceRangeQuery}
              isOpen={isOpen}
              title={title}
              key={title}
              marginBottom={wrapItems ? 6 : 0}
              flex={{ _: '1 1 50%', sm2: wrapItems ? '0 0 50%' : 'none' }}
              targetGiftCount={priceRange.targetGiftCount}
              completedGiftCount={priceRange.currentGiftCount}
            />
          );
        })}
      </Flex>
    </>
  );
};
